import { resolveCanvasSurfaceSize } from "./resolveCanvasSurfaceSize";

export interface PositionedItem {
  x: number;
  y: number;
}

export function resizeCanvasKeepingPositions(canvas: HTMLCanvasElement, items: readonly PositionedItem[]): void {
  const previousWidth = canvas.width;
  const previousHeight = canvas.height;
  const { width, height } = resolveCanvasSurfaceSize(canvas);
  canvas.width = width;
  canvas.height = height;

  if (previousWidth <= 0 || previousHeight <= 0) {
    return;
  }
  const scaleX = width / previousWidth;
  const scaleY = height / previousHeight;
  for (const item of items) {
    item.x *= scaleX;
    item.y *= scaleY;
  }
}
